<template>
    <div class="page no-top-bar have-menu">
        <div>
            <TopBarDetail
                :title="lbl.helpchat.title"
                :isShowBack="true"
                :isShowFavorite="false"
                :isShowShare="false"
                @clickBack="clickBack()"
            ></TopBarDetail>
            <div class="px-5">
                <div class="flex items-center">
                    <div><img class="w-8 h-auto" src="@/assets/icon/icon-helpchat.png" alt=""/></div>
                    <div class="text-20 pl-2.5 font-semibold text-a-blue-0069a8">{{lbl.helpchat.title}}</div>
                    <div class="ml-auto bg-white font-semibold rounded-3xl py-0.5 px-1.5">
                        <span class="text-14 text-a-gray-666666">{{lbl.helpchat.help_code}} {{helpCode}}</span>
                    </div>
                </div>
                <div class="pt-2.5 text-16 text-a-blue-0069a8 font-semibold">{{lbl.helpchat.open_date}}</div>
                <HelpchatList
                    :initListConfig="listConfig"
                    :modalController="modalController"
                    ref="helpChatlist">
                </HelpchatList>
            </div>
            <div>
                <AddComment
                    ref="helpchat-addcomment"
                    :modalController="modalController"
                    @saveCommentSuccess="saveCommentSuccess($event)">
                </AddComment>
            </div>
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//component
import TopBarDetail from "@/components/Layout/TopBar/TopBarDetail.vue";
import HelpchatList from "../component/HelpchatList.vue";
import AddComment from "../component/AddComment.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import { CampaignListConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel.js";
import BzbsHelpchat from "@/core/Helpchat/BzbsHelpchat.js"
//helper

export default ({
    name: 'helpchat',
    mixins: [LocaleMixin, AuthPageMixin, ModalMixin],
    components: {
        TopBarDetail,
        HelpchatList,
        AddComment,
    },
    data: function() {
        return {
            profileData: null,
            helpCode: "",
            listConfig: null,
        }
    },
    created: function() {
        this.setScrollLoadMore();
        this.initialConfig();

        this.tracking.screenName('online_survey');
        this.tracking.event('online_survey', 'view_online_survey');
    },
    mounted: function () {
        this.initialHelpchat();
    },
    methods: {
        // onAccountInit: function() {
        //     this.profileData = this.profile;
        //     this.initialHelpchat();
        // },
        clickBack: function () {
            this.$router.back();
        },
        initialConfig: function() {
            let listConfig = new CampaignListConfigBuilder()
                .setTop(25)
                .create();
            this.listConfig = listConfig;
        },
        initialHelpchat: async function () {
            this.loadingModal.show();
            await this.getHelpchatCode();
            this.loadingModal.hide();
        },
        getHelpchatCode: function () {
            return new Promise((resolve) => {
                BzbsProfile.getProfileHelpchat().subscribe({
                    next: (data) => {
                        this.helpCode = data.code;
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        },
        saveCommentSuccess: function (dataSave) {
            this.tracking.event('online_survey', 'create_comment');
            this.loadingModal.show();
            return new Promise((resolve) => {
                BzbsHelpchat.apiSaveComment(dataSave.content, "source", dataSave.objUpload).subscribe({
                    next: (data) => {
                        this.loadingModal.hide();
                        console.log(data);
                        this.$refs['helpchat-addcomment'].removeImage();
                        this.$refs['helpchat-addcomment'].content = "";
                        this.$refs['helpChatlist'].reinitList();
                        resolve(true);
                    },
                    error: (err) => {
                        this.loadingModal.hide();
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow && pageHeight > 10) {
                    this.loadMore();
                }
            };
        },
        loadMore: function () {
            this.$refs['helpChatlist'].loadMore();
        }
    }
})
</script>
